<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="mycenter">
        <div class="mycenter-left">
          <div class="mycenter-left-top">
            <div class="mycenter-left-head">

              <el-upload class="avatar-uploader" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :on-success="updatepicture" v-if="(roleId == me)">
                <img v-if="!(headicon_header)" class="mycenterheadpicture" src="../assets/images/mycenterheadpicture.png">
                <img v-else class="mycenterheadpicture" :src="headicon">
              </el-upload>
              <img v-if="!(headicon_header)&& !(roleId == me)" class="mycenterheadpicture" src="../assets/images/mycenterheadpicture.png">
              <img v-if="(headicon_header)&& !(roleId == me)" class="mycenterheadpicture" :src="headicon">
              <div class="username" @click="dialogFormVisible_name = true" v-if="(roleId == me)"><img class="headpicture" src="../assets/images/moments_headpicture.png" />{{ username }}</div>
              <div class="username" v-else><img class="headpicture" src="../assets/images/moments_headpicture.png" />{{ username }}</div>
            </div>
            <ul class="mycenter-left-content">
              <li class="vipdiv">
                <img class="vip" :src="levelIcon" v-if="this.realState"><span class="viptype" v-if="this.realState">{{ vip }}</span>
                <span class="viptype" v-else>普通会员</span>
                <span class="sex" v-if="this.companyrealState || this.realState">{{sex ? "女" : "男"}}</span>
              </li>
              <li v-if="roleId == me">
                <span class="surename" v-if="this.realState">已实名</span>
                <router-link to="/nameverify" v-else><span class="surename">立即实名认证</span></router-link>

                <span class="surename" v-if="this.companyrealState">企业已认证</span>

                <span class="surename" v-else @click="pushcompany">立即企业认证</span>
              </li>

              <li class="sign" @click="opensign" v-if="signvalue">{{ signvalue }}</li>
              <li class="sign" @click="opensign" v-else>这家伙暂无个性签名...</li>
              <div class="chatcontainer" v-if="!(roleId == me)">

                <div class="chatitem">
                  <router-link :to="{path:'friend',query:{chatId:roleId}}"><img class="chatitemimg" src="../assets/images/privatechat.png">
                    <div class="chattext">私聊</div>

                  </router-link>
                </div>

                <div class="chatitem" @click="opendialog" v-if="!isFri"><img class="chatitemimg" src="../assets/images/addfriend.png">
                  <div class="chattext">添加好友</div>

                </div>
                <div class="chatitem" v-else @click="deletefriend"><img class="chatitemimg" src="../assets/images/delete_ico.png">
                  <div class="chattext">删除好友</div>

                </div>
                <div class="chatitem" @click="open()"><img v-if="carevalue" class="chatitemimg" src="../assets/images/cared.png"><img v-else class="chatitemimg" src="../assets/images/uncare.png">
                  <div class="chattext" v-if="carevalue">取消关注</div>
                  <div class="chattext" v-else>关注TA</div>
                </div>
                <div class="chatitem" @click="centerDialogVisible = true"><img class="chatitemimg" src="../assets/images/complain.png">
                  <div class="chattext">投诉</div>

                </div>

              </div>
            </ul>

          </div>
          <div class="mycenter-left-footer">

            <div class="score"><span class="scorenum">积分值</span>
              <span class="num" v-if="integralNum">{{integralNum > 1000 && realState == 0 ? 1000 : integralNum}}</span>
              <span class="num" v-else>0</span>
            </div>

            <div class="score"><span class="scorenum">财富值</span>
              <span class="num">{{ moneyNum ? moneyNum : 0}}</span>
            </div>
            <div class="score"><span class="scorenum">活跃度 </span><span class="num">{{ activeNum ? activeNum :0 }}</span></div>

          </div>
        </div>

        <div class="mycenter-right">
          <div class="description">
            <li class="topbottom">企业
              <!-- <div>
                <div v-for="item in companyItems" :key="item.id">{{ item.name }}</div>
              </div> -->
              <div class="companyname" v-for="item in companyItems" :key="item.id" v-if="item.name">{{item.name }}<span v-if="item.isBd">（自主认证）</span>
                <span v-else>（客服）</span>
              </div>
            </li>

            <div id="industry1">

            </div>

            <li class="topbottom">行业
            </li>
            <div id="industry1">
              <el-tag v-for="(item, i) in industryItems " :key="i" type="info">{{item.name}}</el-tag>

            </div>

            <li class="topbottom">大区
            </li>
            <div id="industry2">
              <el-tag type="info" v-for="(item, i) in regionItems " :key="i">{{item.name}}</el-tag>
            </div>
            <!-- <li class="flex" id="phone" v-if="(tel1State)&&(tel1)">
              <div><i class="el-icon-phone"></i>手机号1<span class="phonenumber">{{ tel1 }}</span></div> <span v-if="(roleId == me)" @click="changevis()" class="vis">{{ isvis }}</span>
            </li>
            <li class="flex" id="phone" v-if="(tel2State)&&tel2">
              <div><i class="el-icon-phone"></i>手机号2<span class="phonenumber">{{ tel2 }}</span></div> <span v-if="(roleId == me)" @click="changevis()" class="vis">{{ isvis }}</span>
            </li>
            <li class="flex" id="phone" v-if="(!tel3State)&&tel3">
              <div><i class="el-icon-phone"></i>手机号3<span class="phonenumber">{{ tel3 }}</span></div> <span v-if="(roleId == me)" @click="changevis()" class="vis">{{ isvis }}</span>
            </li> -->
            <div v-if="(roleId == me)">
              <li class="flex" id="phone" v-if="tel1">
                <div><i class="el-icon-phone"></i>手机号1<span class="phonenumber">{{ tel1 }}</span></div> <span v-if="(roleId == me)" @click="changevis()" class="vis">
                  <div v-if="tel1State == 0">已显示</div>
                  <div v-else>已隐藏</div>
                </span>
              </li>
              <li class="flex" id="phone" v-if="tel2">
                <div><i class="el-icon-phone"></i>手机号2<span class="phonenumber">{{ tel2 }}</span></div> <span v-if="(roleId == me)" @click="changevis()" class="vis">
                  <div v-if="tel2State == 0">已显示</div>
                  <div v-else>已隐藏</div>
                </span>
              </li>
              <li class="flex" id="phone" v-if="tel3">
                <div><i class="el-icon-phone"></i>手机号3<span class="phonenumber">{{ tel3 }}</span></div> <span v-if="(roleId == me)" @click="changevis()" class="vis">
                  <div v-if="tel3State == 0">已显示</div>
                  <div v-else>已隐藏</div>
                </span>
              </li>
            </div>
            <div v-else>
              <li class="flex" id="phone" v-if="(!tel1State)&&tel1">
                <div><i class="el-icon-phone"></i>手机号1<span class="phonenumber">{{ tel1 }}</span></div>
              </li>
              <li class="flex" id="phone" v-if="(!tel2State)&&tel2">
                <div><i class="el-icon-phone"></i>手机号2<span class="phonenumber">{{ tel2 }}</span></div>
              </li>
              <li class="flex" id="phone" v-if="(!tel3State)&&tel3">
                <div><i class="el-icon-phone"></i>手机号3<span class="phonenumber">{{ tel3 }}</span></div>
              </li>
            </div>

            <li class="flex" id="phone" v-if="(roleId == me)">好友权限<span @click="changeverify()" class="friend" v-if="friendsState">需要验证</span>
              <span @click="changeverify()" class="friend" v-else>无需验证</span></li>
            <router-link to="/judge">
              <li id="phone" v-if="(roleId == me)">投诉管理</li>
            </router-link>
            <li id="del" v-if="(roleId == me)" @click="delaccount">账户注销</li>
          </div>

        </div>
      </div>
      <el-dialog title="投诉" :visible.sync="centerDialogVisible" width="30%" center>
        <span>
          <el-input type="textarea" placeholder="请填写投诉理由" v-model="textarea" maxlength="500" show-word-limit :autosize="{ minRows: 3, maxRows: 9 }" resize="none">
          </el-input>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitcomplaint">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
  <el-dialog title="个性签名" :visible.sync="dialogFormVisible" width="30%" center>
    <el-form :model="form">
      <el-form-item>
        <el-input v-model="signvalue_modify" autocomplete="off" placeholder="请输入您的个性签名"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogFormVisible = false;changesign()">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="昵称" :visible.sync="dialogFormVisible_name" width="30%" center>
    <el-form :model="form">
      <el-form-item>
        <el-input v-model="username_modify" autocomplete="off" placeholder="请输入您要改的昵称"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible_name = false">取 消</el-button>
      <el-button type="primary" @click="dialogFormVisible_name = false;changeusername()">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="好友分组" :visible.sync="dialogFormVisible_friend" :append-to-body="true">
    <el-dialog width="30%" title="新建分组" :visible.sync="innerVisible" append-to-body>
      <el-form :model="form">
        <el-form-item label="分组名称" :label-width="formLabelWidth">
          <el-input v-model="newgroup" placeholder="请输入分组名称">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="
            newgrouplist
          ">确 定</el-button>
      </div>
    </el-dialog>
    <el-form :model="form">
      <el-form-item label="选择分组" :label-width="formLabelWidth">
        <el-select v-model="groupvalue" placeholder="请选择分组" clearable @change="changegroup">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>

        </el-select>
        <el-button class="newgroup" type="primary" @click="
          innerVisible = true
          ">新建分组</el-button>
      </el-form-item>

      <el-form-item label="备注" :label-width="formLabelWidth">
        <el-input class="note" v-model="note" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="
          dialogFormVisible_friend = false;
        ">取 消</el-button>
      <el-button class="surebutton_group" type="primary" @click="
          submitgroup
        ">确 定</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import {
  updatePersonPic,
  isCollect,
  isFriend,
  complaintadd,
  addCollect,
  cancelCollect,
  addFriend,
  deleteFriend,
  grouplist,
  addgroup,
  deleteaccount
} from "../api/api"
import {
  updatePersonSign,
  updateMininame
} from "../api/api"
import {
  queryById
} from "../api/api"
import {
  updatePhoneState
} from "../api/api"
import {
  updateFriendsState
} from "../api/api"

import transparentheaders from "../components/transparentheaders.vue"
import router from "../router"

const industryItems = []
const regionItems = []
const companyItems = []
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
export default {
  data() {
    return {
      carevalue: "", //初始状态为未关注
      username_modify: "",
      username: "",
      vip: "",
      levelIcon: "", //会员图标
      isverify: "",
      signvalue: "",
      signvalue_modify: "",
      dialogFormVisible: false,
      dialogFormVisible_name: false, //添加好友外部Dialog开关
      innerVisible: false, //内部新建分组开关
      formLabelWidth: "100px",
      centerDialogVisible: false,
      dialogFormVisible_friend: false,
      textarea: "",
      groupvalue: "", //选择分组的值
      newgroup: "", //新建分组的值
      note: "", //备注的值
      friendsState: "", //好友权限
      userid: "", //用户id
      tel1: "", //用户手机号
      tel2: "", //用户手机号
      tel3: "", //用户手机号
      telestate: "", //手机号是否显示
      integralNum: "", //积分值
      activeNum: "", //活跃度
      moneyNum: "", //财富值
      realState: "", //是否显示会员图标
      sex: "", //性别
      form: {

        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      multipartFile: {
        biz: "app_personPic"
      },

      isBd: "0", //是否自主认证
      isFri: "",
      //是否是好友
      options: [],
      industryItems,
      regionItems,
      companyItems,
      imgUrl,
      headicon: "",
      headicon_header: "",
      tel1State: "",
      tel2State: "",
      tel3State: "",
      msg: "", //弹出的消息
      groupId: "", //分组值
      companyrealState: "" //是否企业认证
    }
  },
  components: {
    transparentheaders
  },
  created() {
    //获取路由参数
    this.roleId = this.$route.query.roleId
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id

    console.log(this.roleId)
    isCollect({
      my: this.userid,
      you: this.roleId
    }).then(res => {
      if (res.data.code == 200) {
        this.carevalue = res.data.result
      }
    });
    isFriend({
      my: this.userid,
      you: this.roleId
    }).then(res => {
      if (res.data.code == 200) {
        if (res.result) {
          this.isFri = res.data.result.friendsState
        } else {
          this.isFri = res.data.result
        }
      }
    });
    this.getqueryById();

  },
  computed: {
    me() {
      return JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
    }
  },
  mounted() {

  },
  methods: {
    submitcomplaint() {
      let data = {
        appuserId: this.roleId,
        appuserId2: this.userid,
        complaintContent: this.textarea,
      }
      complaintadd(data).then(res => {
        if (res.data.code == 200) {
          console.log(res.data);
        }
      });
      this.centerDialogVisible = false
    },

    open() {
      if (this.carevalue == true) {
        this.$confirm('确定要取消关注TA吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true

        }).then(() => {

          this.changecare();

        }).catch(() => {

        });
        return
      }
      this.$confirm('确定要关注TA吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true

      }).then(() => {

        this.changecare();

      }).catch(() => {

      });
    },

    init() {
      this.integralNum_warn();

      this.username_modify = this.username;
      this.signvalue_modify = this.signvalue;
      // if (this.signvalue === "" || this.signvalue_modify === "") {
      //   this.signvalue = "这家伙暂无个性签名..."
      // }

    },
    changeusername() {
      this.username = this.username_modify;
      let data = {
        id: this.userid,
        mininame: this.username
      };
      updateMininame(data).then(res => {
        if (res.data.code == 200) {
          // 从sessionStorage中获取存储的数据
          const data = JSON.parse(sessionStorage.getItem('userinfo_Data'));

          // 更新属性的值
          data.mininame = this.username;

          // 将更新后的数据重新存储到sessionStorage中
          sessionStorage.setItem('userinfo_Data', JSON.stringify(data));
          this.update
        }
      });

    },
    changesign() {
      this.signvalue = this.signvalue_modify;
      if (this.signvalue === "" || this.signvalue_modify === "") {
        this.signvalue = "这家伙暂无个性签名..."
      }
      let data = {
        id: this.userid,
        personSign: this.signvalue
      };
      updatePersonSign(data).then(res => {
        if (res.data.code == 200) {
          console.log(res.data);
        }
      });
    },
    changevis() {

      if (this.tel1State) {
        this.tel1State = 0
      } else {
        this.tel1State = 1
      }

      let data = {
        id: this.userid,
        tel1: this.tel1,
        tel1State: this.tel1State
      };
      updatePhoneState(data).then(res => {
        if (res.data.code == 200) {
          console.log(res.data)

        }
      });

    },
    changeverify() {
      if (!this.friendsState) {

        this.friendsState = 1;
      } else {
        this.friendsState = 0;
      }

      let data = {
        friendsState: this.friendsState,
        id: this.userid
      };
      updateFriendsState(data).then(res => {
        if (res.data.code == 200) {
          console.log(res.data);
        }
      });

    },
    changecare() {

      if (this.carevalue == true) {
        let data = {
          appuserId: this.userid,
          collectUserId: this.roleId
        }
        cancelCollect(data).then(res => {
          if (res.data.code == 200) {
            isCollect({
              my: this.userid,
              you: this.roleId
            }).then(res => {
              if (res.data.code == 200) {
                this.carevalue = res.data.result
              }
            });
          }
        });
      } else {
        let data = {
          appuserId: this.userid,
          collectUserId: this.roleId
        }
        addCollect(data).then(res => {
          if (res.data.code == 200) {
            isCollect({
              my: this.userid,
              you: this.roleId
            }).then(res => {
              if (res.data.code == 200) {
                this.carevalue = res.data.result
              }
            });
          }
        });
        this.carevalue = true;
      }

    },

    getqueryById() {
      if (this.roleId == this.userid) {
        queryById({
          id: this.userid
        }).then(res => {
          if (res.data.code == 200) {
            this.headicon_header = res.data.result.personPic;
            this.headicon = this.imgUrl + res.data.result.personPic;
            this.signvalue = res.data.result.personSign
            this.username_modify = this.username;
            this.vip = res.data.result.levelName;
            this.username = res.data.result.mininame;
            this.integralNum = res.data.result.integralNum;
            this.moneyNum = res.data.result.moneyNum;
            this.activeNum = res.data.result.activeNum;
            this.levelIcon = this.imgUrl + res.data.result.levelIcon;
            this.industryItems = res.data.result.industryList;
            this.regionItems = res.data.result.bigRegionList;
            this.companyDesc = res.data.result.companyDesc;
            this.companyItems = res.data.result.companyList;
            this.realState = res.data.result.realState;
            this.sex = res.data.result.sex
            this.tel1 = res.data.result.tel1;
            this.tel2 = res.data.result.tel2;
            this.tel3 = res.data.result.tel3;
            this.tel1State = res.data.result.tel1State;
            this.tel2State = res.data.result.tel2State;
            this.tel3State = res.data.result.tel3State;
            this.companyrealState = res.data.result.companyRealState;
            this.friendsState = res.data.result.friendsState;
            console.log(this.companyrealState)
            this.init();
          }
        });
      } else {
        console.log(this.roleId)
        queryById({
          id: this.roleId,
        }).then(res => {
          if (res.data.code == 200) {
            this.headicon_header = res.data.result.personPic;
            this.headicon = this.imgUrl + res.data.result.personPic;
            this.signvalue = res.data.result.personSign
            this.username_modify = this.username;
            this.vip = res.data.result.levelName;
            this.username = res.data.result.mininame;
            this.integralNum = res.data.result.integralNum;
            this.moneyNum = res.data.result.moneyNum;
            this.activeNum = res.data.result.activeNum;
            this.levelIcon = this.imgUrl + res.data.result.levelIcon;
            this.industryItems = res.data.result.industryList;
            this.regionItems = res.data.result.bigRegionList;
            this.companyDesc = res.data.result.companyDesc;
            this.companyItems = res.data.result.companyList;
            this.realState = res.data.result.realState;
            this.sex = res.data.result.sex
            this.tel1 = res.data.result.tel1;
            this.tel2 = res.data.result.tel2;
            this.tel3 = res.data.result.tel3;
            this.tel1State = res.data.result.tel1State;
            this.tel2State = res.data.result.tel2State;
            this.tel3State = res.data.result.tel3State;

            this.init();
          }
        });
      }
    },
    updatepicture(res) {
      this.headicon_header = res.message
      this.headicon = this.imgUrl + res.message
      let data = {
        id: this.userid,
        personPic: res.message
      };
      updatePersonPic(data).then(res => {
        if (res.data.code == 200) {
          console.log(res.data);
        }
      });
      this.updateinfo();
    },
    updateinfo() {
      let data = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      )
      console.log(data)
      const newData = {
        ...data,
        personPic: this.headicon_header
      };
      sessionStorage.setItem("userinfo_Data", JSON.stringify(newData));
    },
    integralNum_warn() {
      if (this.integralNum >= 1000 && !this.realState) {
        this.openwarn();
      }
    },
    openwarn() {
      if (this.roleId === this.userid) {
        this.$confirm('您的积分已达上限请立即实名认证升级为蓝星会员！', '友情提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {

        }).catch(() => {

        });
      }

    },
    opennotice() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        // if (this.msg === "注册成功") {
        //   this.$router.push({
        //     path: "/"
        //   });
        // }
      });
    },
    opendialog() {
      this.dialogFormVisible_friend = true;
      grouplist({
        userId: this.userid,
      }).then(res => {
        this.options = res.data.result
      });
    },
    newgrouplist() {
      if (this.newgroup) {
        let data = {
          appuserId: this.userid,
          name: this.newgroup,
        }
        addgroup(data).then(res => {
          if (res.data.code == 200) {
            grouplist({
              userId: this.userid,
            }).then(res => {
              this.options = res.data.result
            });
          }

        });

        this.innerVisible = false;
        this.newgroup = "";

      } else {
        this.msg = "分组名不能为空"
        this.opennotice()
      }
    },
    submitgroup() {
      this.openadd();

    },
    changegroup(e) {
      this.groupId = e
    },
    openadd() {
      this.$confirm('确定添加好友吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          appuserId: this.userid,
          friendsId: this.roleId,
          groupId: this.groupId,
          memo: this.note
        }
        addFriend(data).then(res => {
          if (res.data.code == 111) {
            console.log(res.data.message)
            this.msg = res.data.message;
            this.opennotice();
          }
        });
        this.dialogFormVisible_friend = false;
        this.newgroup = ""
        this.groupvalue = ""
        this.note = ""

      }).catch(() => {

      });
    },

    opendelete() {
      this.$confirm('确定删除好友吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          appuserId: this.userid,
          friendsId: this.roleId,
        }
        deleteFriend(data).then(res => {
          if (res.data.code == 200) {
            isFriend({
              my: this.userid,
              you: this.roleId
            }).then(res => {
              if (res.data.code == 200) {
                if (res.result) {
                  this.isFri = res.data.result.friendsState
                } else {
                  this.isFri = res.data.result
                }
              }
            });
          }
        });
      }).catch(() => {

      });

    },
    deletefriend() {
      this.opendelete()

    },
    opensign() {
      if (this.roleId === this.userid) {
        this.dialogFormVisible = true
      }
    },
    opendeletewarn() {
      this.$confirm('你确定要注销您的账户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.userid)

        deleteaccount({
          id: this.userid
        }).then(res => {
          if (res.data.code == 200) {
            sessionStorage.clear();
            this.$router.push({
              path: "/"
            });
          }
        });
      }).catch(() => {

      });
    },
    delaccount() {
      this.opendeletewarn();
    },
    pushcompany() {
      if (this.realState)
        this.$router.push({
          path: "/companyverify",
        });
      else {
        this.msg = "请先实名认证"
        this.opennotice();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  padding: 20px;
  background: rgb(234, 242, 250);
}

.mycenter {
  margin-top: 70px;
  display: flex;
  overflow: hidden;
  min-height: 90vh;
}

.mycenter-left-top {
  text-align: center;
  margin-right: 0px;
  width: 320px;
  padding: 60px 50px 60px 50px;
  background: white;
}

.mycenter-left {
  margin-right: 10px;

}

.mycenter-right {
  background: white;
  padding: 10px;
  width: 100%;
}

.white {
  background: white;
}

.mycenterheadpicture {
  width: 95px;
  height: 95px;
  border-radius: 5px;
  object-fit: cover;
}

.vip {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.mycenter-left-content {
  display: flex;
  margin-top: 10px;
  flex-direction: column;
}

.mycenter-left-footer {
  text-align: center;
  height: 100%;
  background: white;
  margin-top: 10px;
  padding: 30px;
}

ul {
  text-align: center;
}

li {
  margin-top: 20px;
  text-align: none;
}

.mycenter-left-footer li {
  margin-top: 20px;
  margin-left: 100px;
  text-align: center;
}

.username {
  font-size: 16px;
  font-family: "SourceHanSansCN";
  margin-top: 10px;
  font-weight: 600;
  cursor: pointer;
}

.viptype {
  font-size: 13px;
}

.sex {
  font-size: 13px;
}

.surename {
  color: white;
  margin-right: 5px;
  background: rgb(71, 145, 255);
  border-radius: 5px;
  padding: 6px;
  font-size: 14px;
}

.vipdiv {
  margin-top: 0px;
}

.viptype {
  margin-right: 5px;
}

.sign {
  font-size: 13px;
  cursor: pointer;
}

.num {
  text-align: left !important;
  color: black;
  font-size: 22px;
  font-weight: 700;
  transform: translateY(1.6px);
  display: inline-block;
  width: 70px;
  margin-left: 55px;
  /* 设置宽度 */
}

.score {
  margin-top: 20px;
  margin-left: 20px;
}

.scorenum {
  font-size: 15px;
  color: #888;
  font-weight: normal;
  width: 100px;
}

.description {
  margin: 20px 50px;
  display: flex;
  flex-direction: column;
}

.description li {
  margin-top: 0px !important;
}

.topbottom {
  padding-top: 10px;
}

#phone {
  border: none;
  padding: 20px 0px;
  border-top: solid 1px lightgray;
  //  margin-bottom: 10px;
}

#del {
  cursor: pointer;
  border: none;
  padding: 20px 0px;
  border-top: solid 1px lightgray;
  //  margin-bottom: 10px;
}

#industry1 {
  padding: 10px 0px 20px 0px;
  border-bottom: solid 1px lightgray;
}

#industry2 {
  padding: 10px 0px 20px 0px;
  flex-wrap: nowrap;
}

.el-tag {
  margin-top: 10px;
  margin-right: 10px;

  color: white;
  border-radius: 10px;

}

>>>.el-tag.el-tag--info {
  background-color: rgb(71, 145, 255);
  color: white;
}

.phonenumber {
  margin-left: 30px;
  font-size: 14px;
  font-family: "Microsoft Yahei";
}

.friend {
  margin-left: 30px;
  font-size: 14px;
  font-family: "Microsoft Yahei";
  cursor: pointer;
}

.vis {
  margin-left: 30px;
  cursor: pointer;
}

.flex {
  display: flex;
  justify-content: space-between;
}

.headpicture {
  margin-bottom: 2px;
  margin-right: 5px;
}

.company {
  margin-top: 20px;
}

.chatitemimg {
  width: 32px;
  height: 32px;
}

.chatitem {
  min-width: 17%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;

  margin-right: 13px;
}

.chatcontainer {
  display: flex;
  margin: 30px -140px -30px -50px;
  flex-direction: row;
}

.chattext {
  margin-top: 10px;
}

.note {
  width: 250px;
}

>>>.el-upload-list__item {
  display: none;
}

>>>.el-upload-list__item-name {
  transition: none !important;
  display: none;
}

>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}

.companyname {
  margin-top: 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter.vue